
import { useI18n } from 'vue-i18n';
import { computed, Ref } from 'vue';
import { useStore } from 'vuex';
import { saveAs } from 'file-saver';
import Button from '@/components/Button.vue';

export default {
  name: 'Outcome',
  components: { Button },
  setup(): {
    t: (key: string) => string;
    handleDownload: () => void;
  } {
    const { t } = useI18n();
    const store = useStore();

    const handleDownload = () => {
      const file: Ref<File> = computed(() => store.getters['videos/video']);
      if (file.value && file.value.name) {
        saveAs(file.value, file.value.name);
      } else {
        console.warn('No video recorded yet');
      }
    };

    return {
      t,
      handleDownload,
    };
  },
};
